import { Divider, Stack } from "@mui/material";
import { BillingHistory } from "./partials/BillingHistory";
import { PaymentDetails } from "./partials/PaymentDetails";
import { CurrentPlan } from "./partials/CurrentPlan";
import { PaymentStatusModal } from "./partials/PaymentStatusModal";
import { PlanLimitAlert } from "../../components";
import { selectExtension } from "../../features/extension/extension.selector";
import { useAppSelector } from "../../store/hooks";
import PaymentIssueAlert from "../../components/PaymentIssueAlert";
import { selectUserProfile } from "../../features/user/user.selector";
import { isStoreManagedSubscription } from "../../helpers";

const Billing = () => {
  const { isExtension } = useAppSelector(selectExtension);
  const user = useAppSelector(selectUserProfile);
  const isStoreManaged = isStoreManagedSubscription(user?.store);

  return (
    <Stack gap={isExtension ? 1.5 : 3}>
      <PaymentIssueAlert />
      <PlanLimitAlert />
      <CurrentPlan />
      <Divider />
      <PaymentDetails />
      {!isStoreManaged && (
        <>
          <Divider />
          <BillingHistory />
        </>
      )}
      <PaymentStatusModal />
    </Stack>
  );
};

export default Billing;
